module.exports = __webpack_public_path__ + "static/img/CgoRC2ORiVCAX3NyAAjBVMS4amU608.554fa8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRC2ORiVCAX3NyAAjBVMS4amU608.png
// module id = y7rg
// module chunks = 73